(() => {
  const selector = '[data-cl-customer-swatches]';
  if (window.clCustomerSwatches) {
    window.clCustomerSwatches.init(document);
    return;
  }
  const instances = new WeakMap();
  const waiting = new WeakMap();
  const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.split(`[${key}]`).join(String(value)), template || '');
  const setup = (section) => {
    if (instances.has(section)) return true;
    const rail = section.querySelector('.jdgm-carousel__item-container');
    const track = rail && rail.querySelector('.jdgm-carousel__item-wrapper');
    const items = track ? Array.from(track.children).filter((item) => item.matches('.jdgm-carousel-item[data-review-id]')) : [];
    const controls = section.querySelector('.cl-customer-stories__controls');
    const previous = section.querySelector('[data-cl-swatch-previous]');
    const next = section.querySelector('[data-cl-swatch-next]');
    const position = section.querySelector('.cl-customer-stories__position-text');
    if (!rail || !track || !items.length || !controls || !previous || !next || !position) return false;
    const settings = section.dataset;
    rail.id = `${section.id}-rail`;
    rail.tabIndex = 0;
    rail.setAttribute('role', 'region');
    rail.setAttribute('aria-label', settings.railLabel);
    previous.setAttribute('aria-controls', rail.id);
    next.setAttribute('aria-controls', rail.id);
    items.forEach((item, index) => {
      const label = format(settings.storyLabel, { number: String(index + 1).padStart(2, '0') });
      item.setAttribute('role', 'group');
      item.setAttribute('aria-label', label);
      const existingTag = item.querySelector('.cl-customer-stories__swatch-label');
      if (existingTag) existingTag.textContent = label;
      if (!existingTag) {
        const tag = document.createElement('span');
        tag.className = 'cl-customer-stories__swatch-label';
        tag.textContent = label;
        tag.setAttribute('aria-hidden', 'true');
        item.prepend(tag);
      }
      const product = item.querySelector('.jdgm-carousel-item__product');
      const image = product && product.querySelector('img');
      if (!image) return;
      const source = image.getAttribute('data-src');
      const retina = image.getAttribute('data-src-retina');
      if (source && !image.getAttribute('src')) image.setAttribute('src', source);
      if (source && retina && !image.getAttribute('srcset')) image.setAttribute('srcset', `${source} 1x, ${retina} 2x`);
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
      image.setAttribute('width', '72');
      image.setAttribute('height', '72');
      const title = (image.getAttribute('alt') || '').trim();
      if (!title || product.querySelector('.cl-customer-stories__product-caption')) return;
      const caption = document.createElement('div');
      caption.className = 'cl-customer-stories__product-caption';
      caption.setAttribute('aria-hidden', 'true');
      const captionLabel = document.createElement('span');
      captionLabel.textContent = settings.productLabel;
      const captionTitle = document.createElement('strong');
      captionTitle.textContent = title;
      caption.append(captionLabel, captionTitle);
      product.append(caption);
    });
    let frame = 0;
    let resizeObserver;
    let refreshObserver;
    const update = () => {
      frame = 0;
      if (!section.isConnected) return;
      const viewport = rail.getBoundingClientRect();
      const visible = items.map((item, index) => {
        const rect = item.getBoundingClientRect();
        const overlap = Math.max(0, Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left));
        return overlap >= rect.width * .5 ? index : -1;
      }).filter((index) => index !== -1);
      const first = visible.length ? visible[0] : 0;
      const last = visible.length ? visible[visible.length - 1] : first;
      const text = format(first === last ? settings.singlePositionLabel : settings.positionLabel, { first: first + 1, last: last + 1, total: items.length });
      if (position.textContent !== text) position.textContent = text;
      const atStart = rail.scrollLeft <= 3;
      const atEnd = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 3;
      previous.disabled = atStart;
      next.disabled = atEnd;
      section.style.setProperty('--cl-story-progress', `${((last + 1) / items.length) * 100}%`);
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const scroll = (direction) => {
      const card = items[0].getBoundingClientRect();
      const nextCard = items[1] && items[1].getBoundingClientRect();
      const distance = nextCard ? nextCard.left - card.left : card.width;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      rail.scrollBy({ left: direction * distance, behavior });
    };
    const onFocus = (event) => {
      const item = event.target.closest('.jdgm-carousel-item');
      if (!item || !track.contains(item)) return;
      const itemRect = item.getBoundingClientRect();
      const railRect = rail.getBoundingClientRect();
      if (itemRect.left < railRect.left || itemRect.right > railRect.right) {
        rail.scrollBy({ left: itemRect.left - railRect.left - 3, behavior: 'auto' });
      }
    };
    const goPrevious = () => scroll(-1);
    const goNext = () => scroll(1);
    const onKey = (event) => {
      if (event.target !== rail) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        event.stopPropagation();
        scroll(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        event.stopPropagation();
        rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth, behavior: 'auto' });
      }
    };
    previous.addEventListener('click', goPrevious);
    next.addEventListener('click', goNext);
    rail.addEventListener('scroll', schedule, { passive: true });
    rail.addEventListener('keydown', onKey);
    rail.addEventListener('focusin', onFocus);
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(rail);
    } else {
      window.addEventListener('resize', schedule, { passive: true });
    }
    const reset = () => {
      const destroy = instances.get(section);
      if (destroy) destroy();
      try { init(section); } catch (error) {
        section.classList.remove('cl-customer-stories--ready');
        controls.hidden = true;
      }
    };
    refreshObserver = new MutationObserver(() => {
      const currentItems = Array.from(track.children).filter((item) => item.matches('.jdgm-carousel-item[data-review-id]'));
      if (!section.contains(rail) || !rail.contains(track) || currentItems.length !== items.length || currentItems.some((item, index) => item !== items[index])) reset();
    });
    refreshObserver.observe(section, { childList: true, subtree: true });
    section.classList.add('cl-customer-stories--ready');
    controls.hidden = false;
    rail.scrollLeft = 0;
    update();
    instances.set(section, () => {
      window.cancelAnimationFrame(frame);
      if (resizeObserver) resizeObserver.disconnect();
      if (refreshObserver) refreshObserver.disconnect();
      if (!resizeObserver) window.removeEventListener('resize', schedule);
      previous.removeEventListener('click', goPrevious);
      next.removeEventListener('click', goNext);
      rail.removeEventListener('scroll', schedule);
      rail.removeEventListener('keydown', onKey);
      rail.removeEventListener('focusin', onFocus);
      section.classList.remove('cl-customer-stories--ready');
      controls.hidden = true;
      instances.delete(section);
    });
    return true;
  };
  const init = (scope) => {
    const sections = scope.matches && scope.matches(selector) ? [scope] : Array.from(scope.querySelectorAll(selector));
    sections.forEach((section) => {
      let complete = false;
      try { complete = setup(section); } catch (error) {
        section.classList.remove('cl-customer-stories--ready');
        const controls = section.querySelector('.cl-customer-stories__controls');
        if (controls) controls.hidden = true;
      }
      if (complete || waiting.has(section)) return;
      const observer = new MutationObserver(() => {
        let complete = false;
        try { complete = setup(section); } catch (error) {
          section.classList.remove('cl-customer-stories--ready');
        }
        if (complete) {
          observer.disconnect();
          window.clearTimeout(timeout);
          waiting.delete(section);
        }
      });
      observer.observe(section, { childList: true, subtree: true });
      const timeout = window.setTimeout(() => {
        observer.disconnect();
        waiting.delete(section);
      }, 20000);
      waiting.set(section, () => {
        observer.disconnect();
        window.clearTimeout(timeout);
        waiting.delete(section);
      });
    });
  };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((section) => {
      const destroy = instances.get(section) || waiting.get(section);
      if (destroy) destroy();
    });
  });
  window.clCustomerSwatches = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
